import styled from "styled-components";

export const Download = styled.div``;

export const Panel = styled.div`
  background: #fff;
  border-radius: 7px;
  margin-bottom: 2rem;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 2rem;
    border-bottom: 1px solid #f6f6f6;

    .file-format-container {
      > span {
        margin: 0 1rem;
      }

      > span input {
        margin-right: 0.5rem;
      }
    }

    .download-container {
      display: flex;

      > span {
        color: #ffbb32;
        margin-right: 1rem;
        font-weight: bold;
      }
    }
  }

  main {
    padding: 2rem;

    > span {
      margin-right: 2rem;
    }
  }
`;

export const ChartContainer = styled.div`
  background: #fff;
  border-radius: 7px;
  padding: 2rem;
`;

export const DatePeriodSelect = styled.div`
  display: flex;
`;

export const DatePeriod = styled.div`
  padding: 1rem 1.5rem;
  cursor: pointer;
  background: ${(props) => (props.selected ? "#FFBB32" : "inherit")};
  color: ${(props) => (props.selected ? "#FFF" : "#BEBEBE")};
  border-right: 1px solid #eee;

  &:first-child {
    border-top-left-radius: 7px;
  }
`;

export const DateRangeSelectContainer = styled.div`
  display: flex;
  padding-right: 1.5rem;

  > div {
    display: flex;
    align-items: center;
    color: #bebebe;
    padding: 0.5rem 0;

    &.text {
      padding: 1rem 1.5rem;
      font-weight: bold;
    }

    input {
      border: 1px solid #bebebe;
      padding: 0.25rem 0.25rem;
      border-radius: 3px;
      text-align: center;
      color: #bebebe;
    }
  }
`;

export const HotelSelectContainer = styled.div`
  display: flex;
  padding: 1rem 1.5rem;
  color: #bebebe;

  > div {
    width: 100%;
    display: flex;
    align-items: center;

    &.text {
      font-weight: bold;
      padding-right: 0.5rem;
    }

    select {
      border: 1px solid #bebebe;
      padding: 0.25rem 0.25rem;
      border-radius: 3px;
      text-align: center;
      color: #bebebe;
    }
  }
`;
